// extracted by mini-css-extract-plugin
export default {"root":"ListStatics_root__ViYm3","item":"ListStatics_item__tpgiR"};